import React from 'react'
import Accordion from 'react-bootstrap/Accordion'
import { Link } from 'react-router-dom'
import HeaderSix from '../components/header/HeaderSix'
import FooterSix from '../components/footer/FooterSix'
import ScrollAnimation from '../components/motion/ScrollAnimation'

function EbookWhitepaperService() {
    const cards = [
        {
            num: '01',
            title: 'B2B Whitepapers & Executive Reports',
            text: 'The gold standard for building credibility with decision-makers. Research-intensive, argument-driven documents that present a specific problem with authority, examine the landscape honestly, and position your approach as the logical answer, without feeling like a sales brochure. Eight to twenty-five pages. Three to five weeks.',
        },
        {
            num: '02',
            title: "Lead Generation Ebooks & Buyer's Guides",
            text: "Comprehensive gated content that filters for serious buyers, the ones with real budgets and actual authority to make decisions. Definitive buyer's guides. How-to implementation ebooks. Industry overviews. Educational deep-dives. Content that earns the download and starts the relationship before your sales team makes a single call. Twenty to sixty pages. Five to eight weeks.",
        },
        {
            num: '03',
            title: 'Fiction & Novels',
            text: 'Whether you have a complete vision that needs execution or a concept that needs development from the ground up, our fiction ghostwriters produce manuscripts across thrillers, romance, literary fiction, fantasy, science fiction, historical fiction and beyond. Entirely under your name. Entirely your story.',
        },
        {
            num: '04',
            title: 'Non-Fiction, Memoirs & Business Books',
            text: 'We structure, research, interview, and write the book that represents your thinking at its best. The kind of book that opens speaking opportunities, attracts media attention, and establishes you as the person in your field worth listening to.',
        },
        {
            num: '05',
            title: 'Thought Leadership & Research Reports',
            text: 'Annual state-of-industry reports, benchmark surveys, trend analysis, content that other publications cite, journalists quote, and prospects share because nobody else has published it. Thirty to eighty pages. Six to twelve weeks.',
        },
        {
            num: '06',
            title: 'Technical Documentation & Developer Content',
            text: 'Product documentation, implementation guides, API references, and technical whitepapers written with enough accuracy to satisfy engineers and enough clarity to onboard non-technical stakeholders at the same time. Technical depth without the impenetrable jargon.',
        },
        {
            num: '07',
            title: 'Sales Enablement & Internal Content',
            text: 'Battlecards, proposal templates, training guides, customer success playbooks, and onboarding documentation. High-return content that never gets published but changes outcomes every day.',
        },
        {
            num: '08',
            title: 'Content Refresh & Repurposing',
            text: 'We transform existing intellectual property into polished, current content at a fraction of the cost of starting from scratch.',
        },
    ]

    const industries = [
        {
            title: 'Healthcare & Life Sciences',
            text: 'Patient education, clinical guides, RCM reports, compliance documentation and telehealth content.',
        },
        {
            title: 'Technology & SaaS',
            text: 'Technical whitepapers, platform buyer’s guides, developer documentation, benchmark reports and AI explainers.',
        },
        {
            title: 'Financial Services & Fintech',
            text: 'Regulatory guides, investment whitepapers, wealth management content and digital banking reports.',
        },
        {
            title: 'Cybersecurity',
            text: 'Threat intelligence reports, compliance framework guides, security awareness ebooks and incident response playbooks.',
        },
        {
            title: 'Legal & Professional Services',
            text: 'Methodology whitepapers, industry outlook reports, M&A guides and change management playbooks.',
        },
        {
            title: 'Education, Coaching & Personal Development',
            text: 'Course companion guides, self-help books, workbooks, coaching frameworks and educational ebooks.',
        },
        {
            title: 'Publishing & Authors',
            text: 'Fiction manuscripts, non-fiction books, memoirs: any genre, any length, any vision.',
        },
        {
            title: 'Manufacturing & Industrial',
            text: 'Technical documentation, equipment buyer’s guides, safety compliance content, automation ROI reports.',
        },
        {
            title: 'And beyond',
            text: 'If your audience trusts depth over noise, long-form content works for you.',
        },
    ]

    const howWeWork = [
        {
            title: 'Strategy First',
            text: 'We define your audience, goal, competitive landscape, and the angle that makes your content worth reading over everything else already published on the topic. Nothing is written until this is clear.',
        },
        {
            title: 'Research & Interviews',
            text: 'Primary source research plus structured interviews with your subject matter experts. We extract the proprietary knowledge that can’t be found anywhere else and build the credibility that makes readers trust every page.',
        },
        {
            title: 'Outline Approval',
            text: 'A detailed chapter-by-chapter structure reviewed and approved by you before a single word of actual content is written. This is the step most writers skip. It’s why most projects are delivered, only to be completely restructured.',
        },
        {
            title: 'Draft, Review & Revisions',
            text: 'Full first draft. Internal editorial review before you see it. Two full rounds of client revisions included. We continue revising until it’s exactly right not until the contract says we can stop.',
        },
        {
            title: 'Final Delivery',
            text: 'Publication-ready in your preferred format. Supporting assets, including landing page copy, email sequences, and social content, were included where applicable.',
        },
    ]

    const faqs = [
        {
            q: 'What is ghostwriting?',
            a: 'Ghostwriting is the professional practice of writing content: books, ebooks, whitepapers, and articles that are published under the client’s name. The client owns the content completely. The writer is not credited. It is standard practice across business publishing, thought leadership, and commercial fiction.',
        },
        {
            q: 'What is the difference between an ebook and a whitepaper?',
            a: 'An ebook is longer-form educational content designed to build authority and generate leads, typically 20 to 60 pages covering a topic comprehensively. A whitepaper is shorter and more research-intensive, typically 8 to 20 pages, and makes a specific argument aimed at decision-makers.',
        },
        {
            q: 'Does TechDigit ghostwrite fiction and non-fiction books?',
            a: 'Yes. TechDigit’s content team ghostwrites fiction across all major genres, as well as nonfiction, including business books, memoirs, self-help guides, and educational content, all delivered under the client’s name, with full intellectual property ownership transferred upon completion.',
        },
        {
            q: 'Who owns the content after TechDigit writes it?',
            a: 'The client owns everything in full and complete upon final delivery. All intellectual property transfers to the client to publish, modify, license, translate, or repurpose without restriction.',
        },
        {
            q: 'How long does it take to write an ebook or whitepaper?',
            a: 'Whitepapers typically take 3 to 5 weeks. Ebooks take 5 to 8 weeks. Comprehensive research reports and full manuscripts take 8 to 14 weeks, depending on depth and complexity.',
        },
    ]

    return (
        <div className="index-six service-page service-page--content-writing">
            <HeaderSix />
            <main>
                <ScrollAnimation direction="fade" delay={0.03} duration={0.38}>
                    <div className="about-page-breadcrumb">
                        <div className="container">
                            <h1 className="about-page-breadcrumb__title">Ebook & Whitepaper Writing Services</h1>
                        </div>
                    </div>
                </ScrollAnimation>

                <ScrollAnimation direction="up" delay={0.06} duration={0.5}>
                    <section className="td-section rts-section-gap td-service-hero">
                        <div className="container">
                            <div className="td-service-hero__panel">
                                <div className="row align-items-center g-4 g-lg-5">
                                    <div className="col-lg-6">
                                        <div className="td-service-hero__kicker">Ebook &amp; Whitepaper Writing Services</div>
                                        <h2 className="td-service-hero__title">You’re the Expert. Let the World Actually Know It.</h2>
                                        <p className="td-service-hero__lead">
                                            Research-backed, professionally ghostwritten ebooks, whitepapers, fiction,
                                            non-fiction, and long-form content; for businesses building authority and authors
                                            bringing stories to life.
                                        </p>
                                        <div className="button-area">
                                            <Link to="/contactus" className="rts-btn btn-primary">
                                                Schedule Your Free Consultation
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="td-service-hero__visual">
                                            <img
                                                src="/assets/images/about/content.jpg"
                                                alt="Service overview"
                                                loading="lazy"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </ScrollAnimation>

                <ScrollAnimation direction="left" delay={0.08} duration={0.52}>
                    <section className="td-section rts-section-gap">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-xl-9">
                                    <div className="td-section-head td-section-head--left">
                                        <h2 className="td-section-title">
                                            The Knowledge Is in Your Head. The Problem Is Getting It on the Page.
                                        </h2>
                                        <div className="td-title-rule" aria-hidden="true" />
                                    </div>
                                    <p className="disc">
                                        You know more about your subject than most people who’ve published on it. Your
                                        experience is real, your insights are hard-won and your perspective is genuinely
                                        different from the generic content already out there.
                                    </p>
                                    <p className="disc">
                                        But here’s what actually happens. You open a document and write three pages. You get
                                        pulled back into real work. Two weeks later, you open it again, add a paragraph, hate
                                        the tone, and close it. Six months later, a half-finished draft is sitting in a folder that
                                        hasn’t been opened since.
                                    </p>
                                    <p className="disc">
                                        Meanwhile, your competitor just published a 50-page buyer’s guide that your best
                                        prospects are currently using to evaluate vendors. Or a book with their name on it
                                        that’s positioning them as the authority you actually are and they’re not.
                                    </p>
                                    <p className="disc">
                                        Long-form content works. Whitepapers generate qualified leads. Books open doors that
                                        cold outreach never will. Research reports make you the source instead of the
                                        commentator. But only if they actually get written by someone with the skill to make
                                        them worth reading.
                                    </p>
                                    <p className="disc">
                                        That’s what TechDigit’s content team does. We take what’s in your head, do the
                                        research that adds depth to it, and deliver something you’re genuinely proud to put
                                        your name on.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </ScrollAnimation>

                <ScrollAnimation direction="up" delay={0.06} duration={0.48}>
                    <section className="td-section rts-section-gap">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-xl-9">
                                    <div className="td-section-head text-center mb-5">
                                        <p className="td-section-label">What We Write</p>
                                        <h2 className="td-section-title">Every Format. Every Industry. Every Purpose.</h2>
                                        <div className="td-title-rule td-title-rule--center mx-auto" aria-hidden="true" />
                                    </div>
                                </div>
                            </div>
                            <div className="row g-4">
                                {cards.map((c) => (
                                    <div key={c.num} className="col-lg-6">
                                        <div className="pillar-card h-100">
                                            <div className="pillar-card__header">
                                                <div className="pillar-card__head-main">
                                                    <div className="pillar-heading">
                                                        <span className="pillar-number">{c.num}</span>
                                                        <h4 className="pillar-title">{c.title}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="pillar-text">{c.text}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                </ScrollAnimation>

                <ScrollAnimation direction="right" delay={0.08} duration={0.52}>
                    <section className="td-section rts-section-gap">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-12">
                                    <div className="td-section-head td-section-head--left">
                                        <h2 className="td-section-title">
                                            If Your Audience Makes Decisions Based on Who They Trust — You Need This
                                        </h2>
                                        <div className="td-title-rule" aria-hidden="true" />
                                    </div>
                                    <div className="row g-4 mt-1">
                                        {industries.map((it) => (
                                            <div key={it.title} className="col-md-6">
                                                <div className="service-quad-card h-100">
                                                    <h3 className="service-quad-card__title">{it.title}</h3>
                                                    <p className="service-quad-card__text">{it.text}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </ScrollAnimation>

                <ScrollAnimation direction="fade" delay={0.04} duration={0.42}>
                    <section className="td-section rts-section-gap">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-12">
                                    <div className="td-section-head td-section-head--left">
                                        <h2 className="td-section-title">From Brief to Published — Without It Dying in a Shared Drive</h2>
                                        <div className="td-title-rule" aria-hidden="true" />
                                    </div>
                                    <div className="row g-4 mt-1">
                                        {howWeWork.map((s) => (
                                            <div key={s.title} className="col-md-6">
                                                <div className="service-quad-card h-100">
                                                    <h3 className="service-quad-card__title">{s.title}</h3>
                                                    <p className="service-quad-card__text">{s.text}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </ScrollAnimation>

                <ScrollAnimation direction="up" delay={0.06} duration={0.48}>
                    <section className="faq-techdigit td-section td-section--faq rts-faq-section rts-section-gap">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-xl-9">
                                    <div className="faq-techdigit-inner">
                                        <div className="td-section-head text-center mb-5">
                                            <p className="td-section-label">FAQ</p>
                                            <h2 className="td-section-title">Questions People Ask</h2>
                                            <div className="td-title-rule td-title-rule--center mx-auto" aria-hidden="true" />
                                        </div>
                                        <div className="faq-accordion-area">
                                            <Accordion defaultActiveKey="0">
                                                {faqs.map((faq, i) => (
                                                    <Accordion.Item key={i} eventKey={String(i)}>
                                                        <Accordion.Header>{faq.q}</Accordion.Header>
                                                        <Accordion.Body>{faq.a}</Accordion.Body>
                                                    </Accordion.Item>
                                                ))}
                                            </Accordion>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </ScrollAnimation>

                <ScrollAnimation direction="down" delay={0.05} duration={0.44}>
                    <section className="td-section rts-section-gap">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-xl-9 text-center">
                                    <h2 className="td-section-title">
                                        The Book or the Content You’ve Been Meaning to Publish Starts Here
                                    </h2>
                                    <div className="td-title-rule td-title-rule--center mx-auto" aria-hidden="true" />
                                    <p className="disc mt-3">
                                        One free conversation. We’ll talk through your audience, your goal, what already exists
                                        in your space, and which format would make the biggest impact, for your business or
                                        your story.
                                    </p>
                                    <p className="disc">No obligation. No pressure. Just a genuine conversation about what you’re trying to build.</p>
                                    <div className="button-area mt-4">
                                        <Link to="/contactus" className="rts-btn btn-primary">
                                            Schedule Your Free Consultation
                                        </Link>
                                    </div>
                                    <p className="disc mt-3">
                                        info@techdigitsolutions.com
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </ScrollAnimation>
            </main>
            <FooterSix />
        </div>
    )
}

export default EbookWhitepaperService

